import styles from './Design1.css?inline';

export class AffordabilityDesign1 {
  private readonly instanceId: string;
  private containerElement: HTMLDivElement;
  private widgetData: any;
  private language = 'en';
  private response: any;
  private preQualifyBtn?: HTMLButtonElement;

  constructor(
    widgetData: any,
    private onOpen: () => void
  ) {
    this.instanceId = 'aff1-' + Math.random().toString(36).slice(2, 8);
    this.widgetData = widgetData;
    this.containerElement = document.createElement('div');
    this.containerElement.id = `affordability-container-${this.instanceId}`;
    this.injectStyles();
  }

  getContainer() {
    return this.containerElement;
  }

  setLanguage(lang: string) {
    if (lang) this.language = lang.toLowerCase();
  }

  setResponse(res: any) {
    this.response = res;
  }

  setPrimaryColor(color: string) {
    // uses CSS var --primary-color
    if (this.containerElement) {
      this.containerElement.style.setProperty('--primary-color', color || '#000');
    }
  }

  injectStyles() {
    const styleId = 'dabadu-affordability-design1-styles';
    if (!document.getElementById(styleId)) {
      const styleTag = document.createElement('style');
      styleTag.id = styleId;
      styleTag.innerHTML = styles;
      document.head.appendChild(styleTag);
    }
  }

  buildBanner(resp: any) {
    const translations = this.getTranslations();

    if (this.containerElement.hasChildNodes()) {
      // already built
      return;
    }

    this.containerElement.className = 'affordability-banner';

    // logo box
    const dabaduLogoContainer = document.createElement('div');
    dabaduLogoContainer.className = 'affordability-banner__logo-box';
    const dabaduLogo = document.createElement('img');
    dabaduLogo.alt = 'Dabadu';
    dabaduLogo.className = 'logo';
    // responsive logo source
    const updateLogo = () => {
      try {
        if (window.matchMedia('(max-width: 767px)').matches) {
          dabaduLogo.src = 'https://s3.ca-central-1.amazonaws.com/widget-uat.dabadu.dev/dabadu-logo.png';
        } else {
          dabaduLogo.src = 'https://uat-widget.apps.dabadu.ai/dabadu-logo.png';
        }
      } catch (e) {
        dabaduLogo.src = 'https://s3.ca-central-1.amazonaws.com/widget-uat.dabadu.dev/dabadu-logo.png';
      }
    };
    updateLogo();
    window.addEventListener('resize', updateLogo);

    dabaduLogoContainer.appendChild(dabaduLogo);
    this.containerElement.appendChild(dabaduLogoContainer);

    // description / image
    const textContainer = document.createElement('div');
    textContainer.className = 'affordability-banner__desc';

    const descImgContainer = document.createElement('div');
    descImgContainer.className = 'affordability-banner__desc__imgbox';
    const descImg = document.createElement('img');
    descImg.src = 'https://uat-widget.apps.dabadu.ai/purple-mask-1.png';
    descImg.alt = 'Dabadu';
    descImg.className = 'affordability-banner__desc__img';
    descImgContainer.appendChild(descImg);

    const descTextContainer = document.createElement('div');
    descTextContainer.className = 'affordability-banner__desc__content';
    const heading = document.createElement('div');
    heading.className = 'affordability-banner__title';
    heading.innerText = resp?.banners?.['banner1']?.title || translations.title;
    const subText = document.createElement('div');
    subText.className = 'affordability-banner__subtitle';
    subText.innerText = resp?.banners?.['banner1']?.description || translations.subtitle;
    descTextContainer.appendChild(heading);
    descTextContainer.appendChild(subText);

    textContainer.appendChild(descImgContainer);
    textContainer.appendChild(descTextContainer);
    this.containerElement.appendChild(textContainer);

    // action container
    const actionContainer = document.createElement('div');
    actionContainer.className = 'affordability-banner__action-container';

    const buttonContainer = document.createElement('div');
    buttonContainer.className = 'affordability-banner__btn-container';

    const button = document.createElement('button');
    button.id = `pre-qualify-button-${this.instanceId}`;
    button.className = 'affordability-banner__btn';
    button.addEventListener('click', () => {
      // call controller open
      if (typeof this.onOpen === 'function') this.onOpen();
    });
    this.preQualifyBtn = button;
    button.appendChild(document.createTextNode(resp?.banners?.['banner1']?.buttonText || translations.preQualify));
    buttonContainer.appendChild(button);

    const disclaimer = document.createElement('div');
    disclaimer.className = 'affordability-banner__disclaimer-text';
    disclaimer.innerText = resp?.banners?.['banner1']?.note || translations.disclaimer;
    buttonContainer.appendChild(disclaimer);

    actionContainer.appendChild(buttonContainer);

    const poweredByContainer = document.createElement('div');
    poweredByContainer.className = 'powered-by';

    const poweredByLabel = document.createElement('div');
    poweredByLabel.innerText = translations.poweredBy;
    poweredByContainer.appendChild(poweredByLabel);

    const equifaxLogo = document.createElement('img');
    equifaxLogo.src = 'https://uat-widget.apps.dabadu.ai/equifax.png';
    equifaxLogo.alt = 'Equifax';
    equifaxLogo.className = 'equifax-logo';
    poweredByContainer.appendChild(equifaxLogo);

    actionContainer.appendChild(poweredByContainer);
    this.containerElement.appendChild(actionContainer);
  }

  getTranslations() {
    const translations: any = {
      en: {
        title: 'Qualify before you Buy.',
        subtitle: 'Find out how much you can afford in a few easy steps.',
        preQualify: 'Pre-Qualify Now',
        disclaimer: "This won't affect your credit score.",
        poweredBy: 'Powered by',
      },
      es: {
        title: '¡Califica antes de comprar.',
        subtitle: 'Descubra cuánto puede pagar en unos pocos pasos.',
        preQualify: 'PRECALIFÍQUESE AHORA',
        disclaimer: 'Esto no afectará su puntaje de crédito.',
        poweredBy: 'Desarrollado por',
      },
      fr: {
        title: "Qualifiez-vous avant d'acheter.",
        subtitle: 'Découvrez combien vous pouvez vous permettre en quelques étapes faciles.',
        preQualify: 'PRÉQUALIFIEZ-VOUS MAINTENANT',
        disclaimer: "Cela n'affectera pas votre cote de crédit.",
        poweredBy: 'Propulsé par',
      },
    };
    return translations[this.language] || translations.en;
  }

  // optional: update CTA text (dynamic)
  setCtaText(text: string) {
    if (this.preQualifyBtn) this.preQualifyBtn.textContent = text;
  }
}
